import { useCallback, useEffect, useState } from 'react';
import { markInstallPromptInstalled } from '../utils/installPrompt';

export function usePwaInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canUseNativePrompt, setCanUseNativePrompt] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setCanUseNativePrompt(true);
    };

    const handleAppInstalled = () => {
      markInstallPromptInstalled();
      setDeferredPrompt(null);
      setCanUseNativePrompt(false);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferredPrompt) {
      return { outcome: 'unavailable' };
    }

    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setCanUseNativePrompt(false);

    if (choiceResult?.outcome === 'accepted') {
      markInstallPromptInstalled();
    }

    return choiceResult || { outcome: 'unavailable' };
  }, [deferredPrompt]);

  return {
    canUseNativePrompt,
    promptInstall,
  };
}
